import "./style.scss";
import { DatePicker } from "antd";
import type { Moment } from "moment";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

const DatePickerSingleV2 =
  DatePicker.generatePicker<Moment>(momentGenerateConfig);

export default DatePickerSingleV2;
